import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import Intake from "@/pages/Intake";
import Progress from "@/pages/Progress";
import Report from "@/pages/Report";
import Print from "@/pages/Print";
import Lenses from "@/pages/Lenses";
import SharedLens from "@/pages/SharedLens";
import RadarPage from "@/pages/Radar";
import Studio from "@/pages/Studio";
import { Toaster } from "sonner";

function Shell({ children }) {
  return (
    <div className="flex">
      <Sidebar />
      <main className="flex-1 min-h-screen bg-white">{children}</main>
    </div>
  );
}

function PublicShell({ children }) {
  // No sidebar — public-facing radar/shared-lens pages
  return <div className="min-h-screen bg-white">{children}</div>;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/analysis/:id/print" element={<Print />} />
          <Route path="/shared/lens/:shareId" element={<PublicShell><SharedLens /></PublicShell>} />
          <Route path="/radar" element={<PublicShell><RadarPage /></PublicShell>} />
          <Route path="/radar/:id" element={<PublicShell><Report public /></PublicShell>} />
          <Route path="/" element={<Shell><Intake /></Shell>} />
          <Route path="/analysis/:id" element={<Shell><Progress /></Shell>} />
          <Route path="/analysis/:id/report" element={<Shell><Report /></Shell>} />
          <Route path="/lenses" element={<Shell><Lenses /></Shell>} />
          <Route path="/studio" element={<Shell><Studio /></Shell>} />
          <Route path="/studio/:id" element={<Shell><Studio /></Shell>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}
